import { createContext, useContext, useEffect } from 'react';

const LanguageContext = createContext();

// English-only mode. SK/DE language packs were removed.
const SUPPORTED = ['en'];
const STORAGE_KEY = 'app_language';

export const LanguageProvider = ({ children }) => {
  const language = 'en';

  // No-op setter: kept for backward compatibility with components that
  // still destructure { setLanguage } from the context.
  const setLanguage = () => {};

  useEffect(() => {
    // Force <html lang="en"> and purge any stale SK/DE value from previous sessions
    document.documentElement.lang = 'en';
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && stored !== 'en') {
        localStorage.setItem(STORAGE_KEY, 'en');
      }
    } catch (_) {
      // ignore localStorage errors (private mode, etc.)
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, SUPPORTED }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
